<p class="fms-notification-title" *ngIf="title">{{ title }}</p>
<button
  type="button"
  class="fms-notification-video"
  (click)="open()"
  [style.backgroundImage]="thumbnailUrl ? 'url(' + thumbnailUrl + ')' : null"
>
  <vng-icon name="play_circle" [outline]="false" color="inherit"></vng-icon>
</button>
<p class="fms-notification-body" *ngIf="body">{{ body }}</p>
